import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { DriverUtils } from "../DriverUtils";
import { AuroraMysqlQueryRunner } from "./AuroraMysqlQueryRunner";
import { DateUtils } from "../../util/DateUtils";
import { PlatformTools } from "../../platform/PlatformTools";
import { RdbmsSchemaBuilder } from "../../schema-builder/RdbmsSchemaBuilder";
import { OrmUtils } from "../../util/OrmUtils";
import { ApplyValueTransformers } from "../../util/ApplyValueTransformers";
import { TypeORMError } from "../../error";
import { InstanceChecker } from "../../util/InstanceChecker";
/**
 * Organizes communication with MySQL DBMS.
 */
export var AuroraMysqlDriver = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function AuroraMysqlDriver(connection) {
    var _this = this;
    _classCallCheck(this, AuroraMysqlDriver);
    /**
     * Indicates if replication is enabled.
     */
    this.isReplicated = false;
    /**
     * Indicates if tree tables are supported by this driver.
     */
    this.treeSupport = true;
    /**
     * Represent transaction support by this driver
     */
    this.transactionSupport = "nested";
    /**
     * Gets list of supported column data types by a driver.
     *
     * @see https://www.tutorialspoint.com/mysql/mysql-data-types.htm
     * @see https://dev.mysql.com/doc/refman/8.0/en/data-types.html
     */
    this.supportedDataTypes = [
    // numeric types
    "bit", "int", "integer", "tinyint", "smallint", "mediumint", "bigint", "float", "double", "double precision", "real", "decimal", "dec", "numeric", "fixed", "bool", "boolean",
    // date and time types
    "date", "datetime", "timestamp", "time", "year",
    // string types
    "char", "nchar", "national char", "varchar", "nvarchar", "national varchar", "blob", "text", "tinyblob", "tinytext", "mediumblob", "mediumtext", "longblob", "longtext", "enum", "set", "binary", "varbinary",
    // json data type
    "json",
    // spatial data types
    "geometry", "point", "linestring", "polygon", "multipoint", "multilinestring", "multipolygon", "geometrycollection"];
    /**
     * Returns type of upsert supported by driver if any
     */
    this.supportedUpsertType = "on-duplicate-key-update";
    /**
     * Gets list of spatial column data types.
     */
    this.spatialTypes = ["geometry", "point", "linestring", "polygon", "multipoint", "multilinestring", "multipolygon", "geometrycollection"];
    /**
     * Gets list of column data types that support length by a driver.
     */
    this.withLengthColumnTypes = ["char", "varchar", "nvarchar", "binary", "varbinary"];
    /**
     * Gets list of column data types that support length by a driver.
     */
    this.withWidthColumnTypes = ["bit", "tinyint", "smallint", "mediumint", "int", "integer", "bigint"];
    /**
     * Gets list of column data types that support precision by a driver.
     */
    this.withPrecisionColumnTypes = ["decimal", "dec", "numeric", "fixed", "float", "double", "double precision", "real", "time", "datetime", "timestamp"];
    /**
     * Gets list of column data types that supports scale by a driver.
     */
    this.withScaleColumnTypes = ["decimal", "dec", "numeric", "fixed", "float", "double", "double precision", "real"];
    /**
     * Gets list of column data types that supports UNSIGNED and ZEROFILL attributes.
     */
    this.unsignedAndZerofillTypes = ["int", "integer", "smallint", "tinyint", "mediumint", "bigint", "decimal", "dec", "numeric", "fixed", "float", "double", "double precision", "real"];
    /**
     * ORM has special columns and we need to know what database column types should be for those columns.
     * Column types are driver dependant.
     */
    this.mappedDataTypes = {
      createDate: "datetime",
      createDatePrecision: 6,
      createDateDefault: "CURRENT_TIMESTAMP(6)",
      updateDate: "datetime",
      updateDatePrecision: 6,
      updateDateDefault: "CURRENT_TIMESTAMP(6)",
      deleteDate: "datetime",
      deleteDatePrecision: 6,
      deleteDateNullable: true,
      version: "int",
      treeLevel: "int",
      migrationId: "int",
      migrationName: "varchar",
      migrationTimestamp: "bigint",
      cacheId: "int",
      cacheIdentifier: "varchar",
      cacheTime: "bigint",
      cacheDuration: "int",
      cacheQuery: "text",
      cacheResult: "text",
      metadataType: "varchar",
      metadataDatabase: "varchar",
      metadataSchema: "varchar",
      metadataTable: "varchar",
      metadataName: "varchar",
      metadataValue: "text"
    };
    /**
     * Default values of length, precision and scale depends on column data type.
     * Used in the cases when length/precision/scale is not specified by user.
     */
    this.dataTypeDefaults = {
      varchar: {
        length: 255
      },
      nvarchar: {
        length: 255
      },
      "national varchar": {
        length: 255
      },
      char: {
        length: 1
      },
      binary: {
        length: 1
      },
      varbinary: {
        length: 255
      },
      decimal: {
        precision: 10,
        scale: 0
      },
      dec: {
        precision: 10,
        scale: 0
      },
      numeric: {
        precision: 10,
        scale: 0
      },
      fixed: {
        precision: 10,
        scale: 0
      },
      float: {
        precision: 12
      },
      double: {
        precision: 22
      },
      time: {
        precision: 0
      },
      datetime: {
        precision: 0
      },
      timestamp: {
        precision: 0
      },
      bit: {
        width: 1
      },
      int: {
        width: 11
      },
      integer: {
        width: 11
      },
      tinyint: {
        width: 4
      },
      smallint: {
        width: 6
      },
      mediumint: {
        width: 9
      },
      bigint: {
        width: 20
      }
    };
    /**
     * Max length allowed by MySQL for aliases.
     * @see https://dev.mysql.com/doc/refman/5.5/en/identifiers.html
     */
    this.maxAliasLength = 63;
    this.cteCapabilities = {
      enabled: false
    };
    this.connection = connection;
    this.options = connection.options;
    // load mysql package
    this.loadDependencies();
    this.client = new this.DataApiDriver(this.options.region, this.options.secretArn, this.options.resourceArn, this.options.database, function (query, parameters) {
      return _this.connection.logger.logQuery(query, parameters);
    }, this.options.serviceConfigOptions, this.options.formatOptions);
    this.database = DriverUtils.buildDriverOptions(this.options).database;
    // validate options to make sure everything is set
    // todo: revisit validation with replication in mind
    // if (!(this.options.host || (this.options.extra && this.options.extra.socketPath)) && !this.options.socketPath)
    //     throw new DriverOptionNotSetError("socketPath and host");
    // if (!this.options.username)
    //     throw new DriverOptionNotSetError("username");
    // if (!this.options.database)
    //     throw new DriverOptionNotSetError("database");
    // todo: check what is going on when connection is setup without database and how to connect to a database then?
    // todo: provide options to auto-create a database if it does not exist yet
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Performs connection to the database.
   */
  _createClass(AuroraMysqlDriver, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var queryRunner;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.database) {
                _context.next = 9;
                break;
              }
              _context.next = 3;
              return this.createQueryRunner("master");
            case 3:
              queryRunner = _context.sent;
              _context.next = 6;
              return queryRunner.getCurrentDatabase();
            case 6:
              this.database = _context.sent;
              _context.next = 9;
              return queryRunner.release();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Makes any action after connection (e.g. create extensions in Postgres driver).
     */
  }, {
    key: "afterConnect",
    value: function afterConnect() {
      return Promise.resolve();
    }
    /**
     * Closes connection with the database.
     */
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function disconnect() {
        return _disconnect.apply(this, arguments);
      }
      return disconnect;
    }()
    /**
     * Creates a schema builder used to build and sync a schema.
     */
  }, {
    key: "createSchemaBuilder",
    value: function createSchemaBuilder() {
      return new RdbmsSchemaBuilder(this.connection);
    }
    /**
     * Creates a query runner used to execute database queries.
     */
  }, {
    key: "createQueryRunner",
    value: function createQueryRunner(mode) {
      var _this2 = this;
      return new AuroraMysqlQueryRunner(this, new this.DataApiDriver(this.options.region, this.options.secretArn, this.options.resourceArn, this.options.database, function (query, parameters) {
        return _this2.connection.logger.logQuery(query, parameters);
      }, this.options.serviceConfigOptions, this.options.formatOptions));
    }
    /**
     * Replaces parameters in the given sql with special escaping character
     * and an array of parameter names to be passed to a query.
     */
  }, {
    key: "escapeQueryWithParameters",
    value: function escapeQueryWithParameters(sql, parameters, nativeParameters) {
      var _this3 = this;
      var escapedParameters = Object.keys(nativeParameters).map(function (key) {
        return nativeParameters[key];
      });
      if (!parameters || !Object.keys(parameters).length) return [sql, escapedParameters];
      sql = sql.replace(/:(\.\.\.)?([A-Za-z0-9_.]+)/g, function (full, isArray, key) {
        if (!parameters.hasOwnProperty(key)) {
          return full;
        }
        var value = parameters[key];
        if (isArray) {
          return value.map(function (v) {
            escapedParameters.push(v);
            return _this3.createParameter(key, escapedParameters.length - 1);
          }).join(", ");
        }
        if (typeof value === "function") {
          return value();
        }
        escapedParameters.push(value);
        return _this3.createParameter(key, escapedParameters.length - 1);
      }); // todo: make replace only in value statements, otherwise problems
      return [sql, escapedParameters];
    }
    /**
     * Escapes a column name.
     */
  }, {
    key: "escape",
    value: function escape(columnName) {
      return "`" + columnName + "`";
    }
    /**
     * Build full table name with database name, schema name and table name.
     * E.g. myDB.mySchema.myTable
     */
  }, {
    key: "buildTableName",
    value: function buildTableName(tableName, schema, database) {
      var tablePath = [tableName];
      if (database) {
        tablePath.unshift(database);
      }
      return tablePath.join(".");
    }
    /**
     * Parse a target table name or other types and return a normalized table definition.
     */
  }, {
    key: "parseTableName",
    value: function parseTableName(target) {
      var driverDatabase = this.database;
      var driverSchema = undefined;
      if (InstanceChecker.isTable(target) || InstanceChecker.isView(target)) {
        var parsed = this.parseTableName(target.name);
        return {
          database: target.database || parsed.database || driverDatabase,
          schema: target.schema || parsed.schema || driverSchema,
          tableName: parsed.tableName
        };
      }
      if (InstanceChecker.isTableForeignKey(target)) {
        var _parsed = this.parseTableName(target.referencedTableName);
        return {
          database: target.referencedDatabase || _parsed.database || driverDatabase,
          schema: target.referencedSchema || _parsed.schema || driverSchema,
          tableName: _parsed.tableName
        };
      }
      if (InstanceChecker.isEntityMetadata(target)) {
        // EntityMetadata tableName is never a path
        return {
          database: target.database || driverDatabase,
          schema: target.schema || driverSchema,
          tableName: target.tableName
        };
      }
      var parts = target.split(".");
      return {
        database: (parts.length > 1 ? parts[0] : undefined) || driverDatabase,
        schema: driverSchema,
        tableName: parts.length > 1 ? parts[1] : parts[0]
      };
    }
    /**
     * Prepares given value to a value to be persisted, based on its column type and metadata.
     */
  }, {
    key: "preparePersistentValue",
    value: function preparePersistentValue(value, columnMetadata) {
      if (columnMetadata.transformer) value = ApplyValueTransformers.transformTo(columnMetadata.transformer, value);
      if (!this.options.formatOptions || this.options.formatOptions.castParameters !== false) {
        return this.client.preparePersistentValue(value, columnMetadata);
      }
      if (value === null || value === undefined) return value;
      if (columnMetadata.type === Boolean) {
        return value === true ? 1 : 0;
      } else if (columnMetadata.type === "date") {
        return DateUtils.mixedDateToDateString(value);
      } else if (columnMetadata.type === "time") {
        return DateUtils.mixedDateToTimeString(value);
      } else if (columnMetadata.type === "json") {
        return JSON.stringify(value);
      } else if (columnMetadata.type === "timestamp" || columnMetadata.type === "datetime" || columnMetadata.type === Date) {
        return DateUtils.mixedDateToDate(value);
      } else if (columnMetadata.type === "simple-array" || columnMetadata.type === "set") {
        return DateUtils.simpleArrayToString(value);
      } else if (columnMetadata.type === "simple-json") {
        return DateUtils.simpleJsonToString(value);
      } else if (columnMetadata.type === "enum" || columnMetadata.type === "simple-enum") {
        return "" + value;
      }
      return value;
    }
    /**
     * Prepares given value to a value to be persisted, based on its column type or metadata.
     */
  }, {
    key: "prepareHydratedValue",
    value: function prepareHydratedValue(value, columnMetadata) {
      if (value === null || value === undefined) return columnMetadata.transformer ? ApplyValueTransformers.transformFrom(columnMetadata.transformer, value) : value;
      if (!this.options.formatOptions || this.options.formatOptions.castParameters !== false) {
        return this.client.prepareHydratedValue(value, columnMetadata);
      }
      if (columnMetadata.type === Boolean || columnMetadata.type === "bool" || columnMetadata.type === "boolean") {
        value = value ? true : false;
      } else if (columnMetadata.type === "datetime" || columnMetadata.type === Date) {
        value = DateUtils.normalizeHydratedDate(value);
      } else if (columnMetadata.type === "date") {
        value = DateUtils.mixedDateToDateString(value);
      } else if (columnMetadata.type === "json") {
        value = typeof value === "string" ? JSON.parse(value) : value;
      } else if (columnMetadata.type === "time") {
        value = DateUtils.mixedTimeToString(value);
      } else if (columnMetadata.type === "simple-array" || columnMetadata.type === "set") {
        value = DateUtils.stringToSimpleArray(value);
      } else if (columnMetadata.type === "simple-json") {
        value = DateUtils.stringToSimpleJson(value);
      } else if ((columnMetadata.type === "enum" || columnMetadata.type === "simple-enum") && columnMetadata.enum && !isNaN(value) && columnMetadata.enum.indexOf(parseInt(value)) >= 0) {
        // convert to number if that exists in possible enum options
        value = parseInt(value);
      } else if (columnMetadata.type === Number) {
        // convert to number if number
        value = !isNaN(+value) ? parseInt(value) : value;
      }
      if (columnMetadata.transformer) value = ApplyValueTransformers.transformFrom(columnMetadata.transformer, value);
      return value;
    }
    /**
     * Creates a database type from a given column metadata.
     */
  }, {
    key: "normalizeType",
    value: function normalizeType(column) {
      if (column.type === Number || column.type === "integer") {
        return "int";
      } else if (column.type === String) {
        return "varchar";
      } else if (column.type === Date) {
        return "datetime";
      } else if (column.type === Buffer) {
        return "blob";
      } else if (column.type === Boolean) {
        return "tinyint";
      } else if (column.type === "uuid") {
        return "varchar";
      } else if (column.type === "simple-array" || column.type === "simple-json") {
        return "text";
      } else if (column.type === "simple-enum") {
        return "enum";
      } else if (column.type === "double precision" || column.type === "real") {
        return "double";
      } else if (column.type === "dec" || column.type === "numeric" || column.type === "fixed") {
        return "decimal";
      } else if (column.type === "bool" || column.type === "boolean") {
        return "tinyint";
      } else if (column.type === "nvarchar" || column.type === "national varchar") {
        return "varchar";
      } else if (column.type === "nchar" || column.type === "national char") {
        return "char";
      } else {
        return column.type || "";
      }
    }
    /**
     * Normalizes "default" value of the column.
     */
  }, {
    key: "normalizeDefault",
    value: function normalizeDefault(columnMetadata) {
      var defaultValue = columnMetadata.default;
      if (defaultValue === null) {
        return undefined;
      }
      if ((columnMetadata.type === "enum" || columnMetadata.type === "simple-enum") && defaultValue !== undefined) {
        return "'".concat(defaultValue, "'");
      }
      if (columnMetadata.type === "set" && defaultValue !== undefined) {
        return "'".concat(DateUtils.simpleArrayToString(defaultValue), "'");
      }
      if (typeof defaultValue === "number") {
        return "".concat(defaultValue);
      }
      if (typeof defaultValue === "boolean") {
        return defaultValue ? "1" : "0";
      }
      if (typeof defaultValue === "function") {
        return defaultValue();
      }
      if (typeof defaultValue === "string") {
        return "'".concat(defaultValue, "'");
      }
      if (defaultValue === undefined) {
        return undefined;
      }
      return "".concat(defaultValue);
    }
    /**
     * Normalizes "isUnique" value of the column.
     */
  }, {
    key: "normalizeIsUnique",
    value: function normalizeIsUnique(column) {
      return column.entityMetadata.indices.some(function (idx) {
        return idx.isUnique && idx.columns.length === 1 && idx.columns[0] === column;
      });
    }
    /**
     * Returns default column lengths, which is required on column creation.
     */
  }, {
    key: "getColumnLength",
    value: function getColumnLength(column) {
      if (column.length) return column.length.toString();
      /**
       * fix https://github.com/typeorm/typeorm/issues/1139
       */
      if (column.generationStrategy === "uuid") return "36";
      switch (column.type) {
        case String:
        case "varchar":
        case "nvarchar":
        case "national varchar":
          return "255";
        case "varbinary":
          return "255";
        default:
          return "";
      }
    }
    /**
     * Creates column type definition including length, precision and scale
     */
  }, {
    key: "createFullType",
    value: function createFullType(column) {
      var type = column.type;
      // used 'getColumnLength()' method, because MySQL requires column length for `varchar`, `nvarchar` and `varbinary` data types
      if (this.getColumnLength(column)) {
        type += "(".concat(this.getColumnLength(column), ")");
      } else if (column.width) {
        type += "(".concat(column.width, ")");
      } else if (column.precision !== null && column.precision !== undefined && column.scale !== null && column.scale !== undefined) {
        type += "(".concat(column.precision, ",").concat(column.scale, ")");
      } else if (column.precision !== null && column.precision !== undefined) {
        type += "(".concat(column.precision, ")");
      }
      if (column.isArray) type += " array";
      return type;
    }
    /**
     * Obtains a new database connection to a master server.
     * Used for replication.
     * If replication is not setup then returns default connection's database connection.
     */
  }, {
    key: "obtainMasterConnection",
    value: function obtainMasterConnection() {
      var _this4 = this;
      return new Promise(function (ok, fail) {
        if (_this4.poolCluster) {
          _this4.poolCluster.getConnection("MASTER", function (err, dbConnection) {
            err ? fail(err) : ok(_this4.prepareDbConnection(dbConnection));
          });
        } else if (_this4.pool) {
          _this4.pool.getConnection(function (err, dbConnection) {
            err ? fail(err) : ok(_this4.prepareDbConnection(dbConnection));
          });
        } else {
          fail(new TypeORMError("Connection is not established with mysql database"));
        }
      });
    }
    /**
     * Obtains a new database connection to a slave server.
     * Used for replication.
     * If replication is not setup then returns master (default) connection's database connection.
     */
  }, {
    key: "obtainSlaveConnection",
    value: function obtainSlaveConnection() {
      var _this5 = this;
      if (!this.poolCluster) return this.obtainMasterConnection();
      return new Promise(function (ok, fail) {
        _this5.poolCluster.getConnection("SLAVE*", function (err, dbConnection) {
          err ? fail(err) : ok(_this5.prepareDbConnection(dbConnection));
        });
      });
    }
    /**
     * Creates generated map of values generated or returned by database after INSERT query.
     */
  }, {
    key: "createGeneratedMap",
    value: function createGeneratedMap(metadata, insertResult, entityIndex) {
      var generatedMap = metadata.generatedColumns.reduce(function (map, generatedColumn) {
        var value;
        if (generatedColumn.generationStrategy === "increment" && insertResult.insertId) {
          // NOTE: When multiple rows is inserted by a single INSERT statement,
          // `insertId` is the value generated for the first inserted row only.
          value = insertResult.insertId + entityIndex;
          // } else if (generatedColumn.generationStrategy === "uuid") {
          //     console.log("getting db value:", generatedColumn.databaseName);
          //     value = generatedColumn.getEntityValue(uuidMap);
        }

        return OrmUtils.mergeDeep(map, generatedColumn.createValueMap(value));
      }, {});
      return Object.keys(generatedMap).length > 0 ? generatedMap : undefined;
    }
    /**
     * Differentiate columns of this table and columns from the given column metadatas columns
     * and returns only changed.
     */
  }, {
    key: "findChangedColumns",
    value: function findChangedColumns(tableColumns, columnMetadatas) {
      var _this6 = this;
      return columnMetadatas.filter(function (columnMetadata) {
        var tableColumn = tableColumns.find(function (c) {
          return c.name === columnMetadata.databaseName;
        });
        if (!tableColumn) return false; // we don't need new columns, we only need exist and changed
        // console.log("table:", columnMetadata.entityMetadata.tableName);
        // console.log("name:", tableColumn.name, columnMetadata.databaseName);
        // console.log("type:", tableColumn.type, this.normalizeType(columnMetadata));
        // console.log("length:", tableColumn.length, columnMetadata.length);
        // console.log("width:", tableColumn.width, columnMetadata.width);
        // console.log("precision:", tableColumn.precision, columnMetadata.precision);
        // console.log("scale:", tableColumn.scale, columnMetadata.scale);
        // console.log("zerofill:", tableColumn.zerofill, columnMetadata.zerofill);
        // console.log("unsigned:", tableColumn.unsigned, columnMetadata.unsigned);
        // console.log("asExpression:", tableColumn.asExpression, columnMetadata.asExpression);
        // console.log("generatedType:", tableColumn.generatedType, columnMetadata.generatedType);
        // console.log("comment:", tableColumn.comment, this.escapeComment(columnMetadata.comment));
        // console.log("default:", tableColumn.default, columnMetadata.default);
        // console.log("enum:", tableColumn.enum, columnMetadata.enum);
        // console.log("default changed:", !this.compareDefaultValues(this.normalizeDefault(columnMetadata), tableColumn.default));
        // console.log("onUpdate:", tableColumn.onUpdate, columnMetadata.onUpdate);
        // console.log("isPrimary:", tableColumn.isPrimary, columnMetadata.isPrimary);
        // console.log("isNullable:", tableColumn.isNullable, columnMetadata.isNullable);
        // console.log("isUnique:", tableColumn.isUnique, this.normalizeIsUnique(columnMetadata));
        // console.log("isGenerated:", tableColumn.isGenerated, columnMetadata.isGenerated);
        // console.log((columnMetadata.generationStrategy !== "uuid" && tableColumn.isGenerated !== columnMetadata.isGenerated));
        // console.log("==========================================");
        var columnMetadataLength = columnMetadata.length;
        if (!columnMetadataLength && columnMetadata.generationStrategy === "uuid") {
          // fixing #3374
          columnMetadataLength = _this6.getColumnLength(columnMetadata);
        }
        return tableColumn.name !== columnMetadata.databaseName || tableColumn.type !== _this6.normalizeType(columnMetadata) || tableColumn.length !== columnMetadataLength || tableColumn.width !== columnMetadata.width || tableColumn.precision !== columnMetadata.precision || tableColumn.scale !== columnMetadata.scale || tableColumn.zerofill !== columnMetadata.zerofill || tableColumn.unsigned !== columnMetadata.unsigned || tableColumn.asExpression !== columnMetadata.asExpression || tableColumn.generatedType !== columnMetadata.generatedType || tableColumn.comment !== _this6.escapeComment(columnMetadata.comment) || !_this6.compareDefaultValues(_this6.normalizeDefault(columnMetadata), tableColumn.default) || tableColumn.enum && columnMetadata.enum && !OrmUtils.isArraysEqual(tableColumn.enum, columnMetadata.enum.map(function (val) {
          return val + "";
        })) || tableColumn.onUpdate !== columnMetadata.onUpdate || tableColumn.isPrimary !== columnMetadata.isPrimary || tableColumn.isNullable !== columnMetadata.isNullable || tableColumn.isUnique !== _this6.normalizeIsUnique(columnMetadata) || columnMetadata.generationStrategy !== "uuid" && tableColumn.isGenerated !== columnMetadata.isGenerated;
      });
    }
    /**
     * Returns true if driver supports RETURNING / OUTPUT statement.
     */
  }, {
    key: "isReturningSqlSupported",
    value: function isReturningSqlSupported() {
      return false;
    }
    /**
     * Returns true if driver supports uuid values generation on its own.
     */
  }, {
    key: "isUUIDGenerationSupported",
    value: function isUUIDGenerationSupported() {
      return false;
    }
    /**
     * Returns true if driver supports fulltext indices.
     */
  }, {
    key: "isFullTextColumnTypeSupported",
    value: function isFullTextColumnTypeSupported() {
      return true;
    }
    /**
     * Creates an escaped parameter.
     */
  }, {
    key: "createParameter",
    value: function createParameter(parameterName, index) {
      return "?";
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Loads all driver dependencies.
     */
  }, {
    key: "loadDependencies",
    value: function loadDependencies() {
      var DataApiDriver = this.options.driver || PlatformTools.load("typeorm-aurora-data-api-driver");
      this.DataApiDriver = DataApiDriver;
      // Driver uses rollup for publishing, which has issues when using typeorm in combination with webpack
      // See https://github.com/webpack/webpack/issues/4742#issuecomment-295556787
      this.DataApiDriver = this.DataApiDriver.default || this.DataApiDriver;
    }
    /**
     * Creates a new connection pool for a given database credentials.
     */
  }, {
    key: "createConnectionOptions",
    value: function createConnectionOptions(options, credentials) {
      credentials = Object.assign({}, credentials, DriverUtils.buildDriverOptions(credentials)); // todo: do it better way
      // build connection options for the driver
      return Object.assign({}, {
        resourceArn: options.resourceArn,
        secretArn: options.secretArn,
        database: options.database,
        region: options.region,
        type: options.type
      }, {
        host: credentials.host,
        user: credentials.username,
        password: credentials.password,
        database: credentials.database,
        port: credentials.port,
        ssl: options.ssl
      }, options.extra || {});
    }
    /**
     * Creates a new connection pool for a given database credentials.
     */
  }, {
    key: "createPool",
    value: function () {
      var _createPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(connectionOptions) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", {});
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function createPool(_x) {
        return _createPool.apply(this, arguments);
      }
      return createPool;
    }()
    /**
     * Attaches all required base handlers to a database connection, such as the unhandled error handler.
     */
  }, {
    key: "prepareDbConnection",
    value: function prepareDbConnection(connection) {
      var logger = this.connection.logger;
      /**
       * Attaching an error handler to connection errors is essential, as, otherwise, errors raised will go unhandled and
       * cause the hosting app to crash.
       */
      if (connection.listeners("error").length === 0) {
        connection.on("error", function (error) {
          return logger.log("warn", "MySQL connection raised an error. ".concat(error));
        });
      }
      return connection;
    }
    /**
     * Checks if "DEFAULT" values in the column metadata and in the database are equal.
     */
  }, {
    key: "compareDefaultValues",
    value: function compareDefaultValues(columnMetadataValue, databaseValue) {
      if (typeof columnMetadataValue === "string" && typeof databaseValue === "string") {
        // we need to cut out "'" because in mysql we can understand returned value is a string or a function
        // as result compare cannot understand if default is really changed or not
        columnMetadataValue = columnMetadataValue.replace(/^'+|'+$/g, "");
        databaseValue = databaseValue.replace(/^'+|'+$/g, "");
      }
      return columnMetadataValue === databaseValue;
    }
    /**
     * Escapes a given comment.
     */
  }, {
    key: "escapeComment",
    value: function escapeComment(comment) {
      if (!comment) return comment;
      comment = comment.replace(/\u0000/g, ""); // Null bytes aren't allowed in comments
      return comment;
    }
  }]);
  return AuroraMysqlDriver;
}();